import React from "react";

// Visuell: BERLIN ─ CUBE · maschinenlesbar (textContent und innerText): "BERLIN-CUBE"
export const BrandWordmark = ({ lineClass = "bg-current opacity-80" }) => (
  <span className="inline-block whitespace-nowrap">
    BERLIN<span className="inline-block w-0 overflow-hidden align-middle">-</span>
    <span aria-hidden className={`inline-block w-4 h-px mx-2 align-middle ${lineClass}`} />
    CUBE
  </span>
);
